module.exports = __webpack_public_path__ + "static/img/10.058b3b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/10.png
// module id = ie5j
// module chunks = 0